import { lazy, Suspense } from 'react';
import SearchEntryAuthGuard from '../components/AuthGuards/SearchEntryAuthGuard';
import RequirePermission from '../components/AuthGuards/RequirePermission';
import HomeEntry from '../components/AuthGuards/HomeEntry';

const Home = lazy(() => import('../pages/Home'));
// The waiting homepage (29 Oct): a confirmed account with no role, at / only. Loaded only when shown.
const WaitingHome = lazy(() => import('../pages/Home/WaitingHome'));
const AboutUs = lazy(() => import('../pages/AboutUs'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const Terms = lazy(() => import('../pages/Terms'));
const RefundPolicy = lazy(() => import('../pages/RefundPolicy'));
const CookieNotice = lazy(() => import('../pages/CookieNotice'));
const Accessibility = lazy(() => import('../pages/Accessibility'));

export const HomeRoutes = [
  {
    index: true,
    // RequirePermission NESTS INSIDE SearchEntryAuthGuard rather than
    // replacing it: the outer guard keeps its existing unauthenticated
    // redirect contract (to /sign-in with a from state), so the inner guard
    // only ever decides the authenticated-but-denied case. Least-invasive
    // composition - neither component changes.
    // HomeEntry (29 Oct) sits between them and only for this route: a signed-in account with a confirmed email and no
    // role gets the waiting homepage; everyone else gets exactly the tree below it, as before.
    element: (
      <Suspense fallback={<></>}>
        <SearchEntryAuthGuard>
          <HomeEntry waitingHome={<WaitingHome />}>
            <RequirePermission permission="search.own">
              <Home />
            </RequirePermission>
          </HomeEntry>
        </SearchEntryAuthGuard>
      </Suspense>
    ),
  },
  {
    path: 'about-us',
    element: (
      <Suspense fallback={<></>}>
        <AboutUs />
      </Suspense>
    ),
  },
  {
    path: 'privacy-policy',
    element: (
      <Suspense fallback={<></>}>
        <PrivacyPolicy />
      </Suspense>
    ),
  },
  {
    path: 'terms',
    element: (
      <Suspense fallback={<></>}>
        <Terms />
      </Suspense>
    ),
  },
  {
    path: 'refund-policy',
    element: (
      <Suspense fallback={<></>}>
        <RefundPolicy />
      </Suspense>
    ),
  },
  {
    path: 'cookie-notice',
    element: (
      <Suspense fallback={<></>}>
        <CookieNotice />
      </Suspense>
    ),
  },
  {
    path: 'accessibility-statement',
    element: (
      <Suspense fallback={<></>}>
        <Accessibility />
      </Suspense>
    ),
  },
];
